import { render, staticRenderFns } from "./Selectbox.vue?vue&type=template&id=8ada9af4&"
import script from "./Selectbox.vue?vue&type=script&lang=js&"
export * from "./Selectbox.vue?vue&type=script&lang=js&"
import style0 from "./Selectbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports